import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios";
import { useQuery } from "@tanstack/react-query";
import { LevelCOverallStatistics, LevelCReportFilter } from "../../types/levelc-reports";

export const useGetLevelCStatistics = (filter: LevelCReportFilter, enabled = true) => {
    const axios = useAxios();
    const { t } = useTranslation();

    const fetchStatistics = async (): Promise<LevelCOverallStatistics> => {
        try {
            const params = new URLSearchParams({
                startDate: filter.startDate,
                endDate: filter.endDate,
            });
            
            if (filter.examTermId) {
                params.append('examTermId', filter.examTermId);
            }
            if (filter.examId) {
                params.append('examId', filter.examId);
            }

            const { data } = await axios.get(`/api/levelcreports/statistics?${params.toString()}`);
            return data;
        } catch (error) {
            throw new Error(t("levelCReports.errors.getStatistics"));
        }
    };

    return useQuery({
        queryKey: ["levelCStatistics", filter],
        queryFn: fetchStatistics,
        enabled: enabled && Boolean(filter.startDate) && Boolean(filter.endDate),
    });
};

